import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import { CustomFieldValueDto } from '@/types/CustomFieldValueDto.ts';

/**
 * Typ pola nie jest już zgadywany: niesie go wiersz rachunku (`BillLine.type`),
 * a składa `BookingBillDto.mapper.ts` z konstrukcji — pola predefiniowane mają
 * go wprost, pola niestandardowe z `CustomFieldDefinitionDto.type`, a opcja,
 * transport i ubezpieczenie to zawsze wybór wariantu. Zostało tu wyłącznie to,
 * czego typ pola sam z siebie nie mówi.
 */

/** Wartości pola tak / nie — te same napisy, co w rachunku. */
export const TOGGLE_YES = 'Tak';
export const TOGGLE_NO = 'Nie';

/** Typ, jaki wolno nieść wartości niestandardowej — cztery i tylko cztery. */
export type CustomFieldType = CustomFieldValueDto['type'];

/**
 * Typ pola zawężony do tego, co wartość niestandardowa w ogóle może nieść.
 *
 * `TableFieldType.supportsCustomValues()` przepuszcza `TEXT`, `LONG_TEXT`,
 * `CHECKBOX` i `DROPDOWN`. Definicja pola niestandardowego innego typu nadać
 * nie może, ale zawężenie zostaje jako bezpiecznik przy złożeniu wiersza
 * z pozycją paczki — kontrakt zapisu przyjmuje tylko tę czwórkę.
 */
export const customFieldTypeOf = (type: FieldType): CustomFieldType => {
  switch (type) {
    case FieldType.LONG_TEXT:
    case FieldType.CHECKBOX:
    case FieldType.DROPDOWN:
      return type;
    default:
      return FieldType.TEXT;
  }
};
